import { useEffect, useRef, useState } from "react";

const DEFAULT = 90;

export const RestTimer = () => {
  const [duration, setDuration] = useState(DEFAULT);
  const [remaining, setRemaining] = useState(0);
  const [running, setRunning] = useState(false);
  const id = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!running) {
      if (id.current) clearInterval(id.current);
      return;
    }
    id.current = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          setRunning(false);
          // simple beep via vibrate when supported
          if ("vibrate" in navigator) navigator.vibrate(200);
          return 0;
        }
        return r - 1;
      });
    }, 1000);
    return () => {
      if (id.current) clearInterval(id.current);
    };
  }, [running]);

  const start = () => {
    setRemaining(duration);
    setRunning(true);
  };

  const mm = String(Math.floor(remaining / 60)).padStart(1, "0");
  const ss = String(remaining % 60).padStart(2, "0");

  return (
    <div className="timer" role="region" aria-label="rest timer">
      <div className="t">{running || remaining > 0 ? `${mm}:${ss}` : `Rest ${duration}s`}</div>
      <div className="controls">
        <button onClick={() => setDuration((d) => Math.max(15, d - 15))} aria-label="-15">
          –15
        </button>
        <button onClick={() => setDuration((d) => d + 15)} aria-label="+15">
          +15
        </button>
        <button onClick={start} aria-label="start">
          {running ? "Restart" : "Start"}
        </button>
      </div>
    </div>
  );
};
